import React from 'react';
import './App.scss';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import BackendSkills from './components/BackendSkills/BackendSkills';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App bg-dark-900 min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <BackendSkills />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;